import { type ReactNode } from 'react'
import styles from './Badge.module.css'

type Variante = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'accent'

interface Props {
  variante?: Variante
  children: ReactNode
}

export function Badge({ variante = 'default', children }: Props) {
  return <span className={`${styles.badge} ${styles[variante]}`}>{children}</span>
}
